export default {
  serviceListByCate: [],
  categoryList: []
}
